export const exportCSVFile = (
  headers: Record<string, string>,
  data: any[],
  fileName: string
) => {
  const convertToCsv = (array: any[]) => {
    const strings = array.map(obj => {
      const stringsArr: string[] = [];

      Object.keys(obj).forEach(objString => {
        stringsArr.push(obj[objString]);
      });

      return stringsArr.join(",");
    });

    return strings.join("\r\n");
  };

  data.unshift(headers);

  const csv = convertToCsv(data);

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
